import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { encryptTransform } from "redux-persist-transform-encrypt";
import authReducer from "./authSlice"

const secretKey = "c@re5";

const reducerList = combineReducers({
    auth: authReducer,
});


const persistConfig = {
    key: "userSession",
    storage,
    transforms: [encryptTransform({ secretKey })],
};

const persistedReducer = persistReducer(persistConfig, reducerList);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
    devTools: false
});

export const persistor = persistStore(store);